import React, { memo } from "react";
import useMerchantsOverview from "./index.hooks";
import { Grid, Typography } from "@material-ui/core";
import { CreateMerchantDialog, AppButton, MerchantCard } from "components";
import AddIcon from "@material-ui/icons/Add";
import AppLogo from "assets/images/banner_image.png";
import { Link } from "react-router-dom";

type MerchantsOverviewProps = {};

const MerchantsOverview = ({}: MerchantsOverviewProps) => {
  const { styles, merchants, handleDialogOpen, t } = useMerchantsOverview();

  return (
    <div className={styles.mainContainer}>
      <CreateMerchantDialog />
      <div className={styles.sectionHeader}>
        <Link to="/">
          <img className={styles.appLogo} src={AppLogo} alt="Adhesion" />
        </Link>
        <Typography variant="h4" className={styles.sectionName}>
          {t("Le tue attivit\u00E0")}
        </Typography>
      </div>
      <div className={styles.merchantsContainer}>
        <Grid container spacing={3}>
          <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
            <AppButton
              className={styles.addMerchant}
              onClick={handleDialogOpen}
            >
              <AddIcon className={styles.addIcon} />
            </AppButton>
          </Grid>
          {merchants.map((merchant) => (
            <Grid key={merchant._id} item xl={2} lg={3} md={4} sm={6} xs={12}>
              <MerchantCard merchant={merchant} />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default memo(MerchantsOverview);
